// src/features/Planning/components/Step10ParkingRequirement.jsx
import {
  Box,
  Text,
  Radio,
  RadioGroup,
  VStack,
  Button,
  Flex,
} from "@chakra-ui/react";

export default function Step10ParkingRequirement({
  formData,
  setFormData,
  onNext,
  onBack,
  isLastStep,
  onSubmit,
  viewMode,
}) {
  const parkingRequirement = formData?.parkingRequirement ?? "";
  const vastuPreference = formData?.vastuPreference ?? "";

  const handleParkingChange = (value) => {
    setFormData({ ...formData, parkingRequirement: value });
  };
  const handleVastuChange = (value) => {
    setFormData({ ...formData, vastuPreference: value });
  };

  const handleAction = isLastStep ? onSubmit : onNext;

  return (
    <Box
      h="600px"
      w="100%"
      maxW="400px"
      mx="auto"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={4}
      py={6}
    >
      <VStack spacing={4} align="stretch" pointerEvents={viewMode ? "none" : "auto"}>

        {/* Page Heading - Step2 style */}
        <Text
          fontSize="17px"
          fontWeight="600"
          color="gray.800"
          textAlign="center"
        >
          Parking & Vastu Preference
        </Text>

        {/* Parking Section Card */}
        <Box
          bg="white"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
          overflow="hidden"
        >
          <Box bg="cyan.50" px={4} py={3} borderBottom="1px solid" borderColor="cyan.100">
            <Text fontWeight="600" color="cyan.700" fontSize="14px">
              🚗 Parking Requirement
            </Text>
          </Box>
          <Box px={4} py={4}>
            <RadioGroup value={parkingRequirement} onChange={handleParkingChange}>
              <VStack align="stretch" spacing={2}>
                {[
                  { value: "bike", label: "🛵 Bike" },
                  { value: "car",  label: "🚗 Car"  },
                  { value: "both", label: "🅿️ Both"  },
                ].map((opt) => (
                  <Box
                    key={opt.value}
                    as="label"
                    display="flex"
                    alignItems="center"
                    gap={3}
                    px={3}
                    py={2}
                    borderRadius="8px"
                    border="1px solid"
                    borderColor={parkingRequirement === opt.value ? "cyan.400" : "gray.200"}
                    bg={parkingRequirement === opt.value ? "cyan.50" : "white"}
                    cursor="pointer"
                    transition="all 0.15s ease"
                    _hover={{ borderColor: "cyan.300", bg: "cyan.50" }}
                  >
                    <Radio value={opt.value} colorScheme="cyan" />
                    <Text fontSize="14px" fontWeight="500" color="gray.700">
                      {opt.label}
                    </Text>
                  </Box>
                ))}
              </VStack>
            </RadioGroup>
          </Box>
        </Box>

        {/* Vastu Section Card */}
        <Box
          bg="white"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
          overflow="hidden"
        >
          <Box bg="orange.50" px={4} py={3} borderBottom="1px solid" borderColor="orange.100">
            <Text fontWeight="600" color="orange.600" fontSize="14px">
              🪔 Vastu Preference
            </Text>
          </Box>
          <Box px={4} py={4}>
            <RadioGroup value={vastuPreference} onChange={handleVastuChange}>
              <VStack align="stretch" spacing={2}>
                {[
                  { value: "yes",                label: "Yes" },
                  { value: "no",                 label: "No" },
                  { value: "as_much_as_possible", label: "As much as possible" },
                ].map((opt) => (
                  <Box
                    key={opt.value}
                    as="label"
                    display="flex"
                    alignItems="center"
                    gap={3}
                    px={3}
                    py={2}
                    borderRadius="8px"
                    border="1px solid"
                    borderColor={vastuPreference === opt.value ? "cyan.50" : "white"}
                    bg={vastuPreference === opt.value ? "cyan.50" : "white"}
                    cursor="pointer"
                    transition="all 0.15s ease"
                    _hover={{ borderColor: "cyan.50", bg: "cyan.50" }}
                  >
                    <Radio value={opt.value} colorScheme="cyan" />
                    <Text fontSize="14px" fontWeight="500" color="gray.700">
                      {opt.label}
                    </Text>
                  </Box>
                ))}
              </VStack>
            </RadioGroup>
          </Box>
        </Box>

      </VStack>

      {/* Fixed Navigation Buttons */}
      <Flex justify="space-between" gap={3} mt={4} flexShrink={0}>
        <Button
          onClick={onBack}
          variant="solid"
          bg="white"
          color="cyan.600"
          border="1px solid"
          borderColor="cyan.500"
          borderRadius="6px"
          minW="100px"
          h="40px"
          fontWeight="500"
          fontSize="14px"
          _hover={{ bg: "cyan.50", borderColor: "cyan.600" }}
        >
          ← Previous
        </Button>

        <Button
          onClick={handleAction}
          variant="solid"
          bg="cyan.500"
          color="white"
          border="none"
          borderRadius="6px"
          minW="100px"
          h="40px"
          fontWeight="500"
          fontSize="14px"
          ml="auto"
          _hover={{ bg: "cyan.600" }}
        >
          {isLastStep ? "Submit" : "Next →"}
        </Button>
      </Flex>
    </Box>
  );
}